/**
 * Supported button colors.
 */
export const COLORS = {
    GREEN: 'green',
    BLUE: 'blue',
    LIGHT_GREY: 'light-grey',
    GREY: 'grey',
    BLACK: 'black',
    PRO: 'pro',
    RED: 'red',
    PINK: 'pink',
    ORANGE: 'orange',
    WHITE: 'white'
} as const;

/**
 * Supported button text colors. Relevant only for white buttons.
 */
export const TEXT_COLORS = {
    GREEN: 'green',
    DARK_GREY: 'dark-grey',
    BLUE: 'blue',
    ORANGE: 'orange',
    RED: 'red'
} as const;

/**
 * Supported button sizes.
 */
export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
} as const;

/**
 * Supported button fills.
 */
export const FILLS = {
    FULL: 'full',
    GHOST: 'ghost'
} as const;
